import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Landing.css';

const Landing: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="landing-container">

      {/* Main Content */}
      <div className="landing-content">
        <div className="content-left">
          <h1 className="landing-headline">
            Unlock Top Test Management You Thought Was Out of Reach – Now Just One Click Away!
          </h1>
          <button className="cta-button" onClick={() => navigate('/login')}>
            Start Project <span className="arrow">→</span>
          </button>
          <div className="trust-badge">
            <div className="badge-arrow">→</div>
            <div className="badge-name">Trusted by HR Teams</div>
          </div>
        </div>

        <div className="content-right">
          <div className="network-visualization">
            <div className="network-rings">
              <div className="ring ring-outer"></div>
              <div className="ring ring-middle"></div>
              <div className="ring ring-inner"></div>
            </div>
            
            {/* Avatars */}
            <div className="avatar avatar-1">
              <div className="avatar-img">👩</div>
            </div>
            <div className="avatar avatar-2">
              <div className="avatar-img">👨</div>
            </div>
            <div className="avatar avatar-3">
              <div className="avatar-img">👩</div>
            </div>
            <div className="avatar avatar-4">
              <div className="avatar-img">👩</div>
            </div>
            <div className="avatar avatar-5">
              <div className="avatar-img">👨</div>
            </div>

            {/* Icons */}
            <div className="network-icon icon-1">
              <div className="icon-glow"></div>
              <span>☁️</span>
            </div>
            <div className="network-icon icon-2">
              <div className="icon-glow"></div>
              <span>💬</span>
            </div>
            <div className="network-icon icon-3">
              <div className="icon-glow"></div>
              <span>📢</span>
            </div>
            <div className="network-icon icon-4">
              <div className="icon-glow"></div>
              <span>👤</span>
            </div>

            {/* Center Stats */}
            <div className="center-stats">
              <div className="stat-number">10k+</div>
              <div className="stat-label">Tests Created</div>
            </div>
          </div>
        </div>
      </div>

      {/* Partners/Footer */}
      <div className="landing-partners">
        <div className="partner">
          <span className="partner-icon">🏢</span>
          <span className="partner-name">Enterprise</span>
        </div>
        <div className="partner">
          <span className="partner-icon">🎓</span>
          <span className="partner-name">Education</span>
        </div>
        <div className="partner">
          <span className="partner-icon">💼</span>
          <span className="partner-name">Corporate</span>
        </div>
        <div className="partner">
          <span className="partner-icon">🚀</span>
          <span className="partner-name">Startups</span>
        </div>
        <div className="partner">
          <span className="partner-icon">⭐</span>
          <span className="partner-name">Premium</span>
        </div>
      </div>
    </div>
  );
};

export default Landing;

